export default {
  content: [
    {
      meta: {
        id: 'I_vL9QJFhI',
        order: 0,
        component: 'CustomerHubVideo',
      },
      styles: {
        customClasses: '',
      },
      content: {
        mode: 'user',
        tagline:
          '<h2>Building a <strong>next-generation</strong> platform that powers personalized experiences and <strong>meaningful connections</strong> for everyone</h2>',
        variant: 'variant1',
        videoUrl: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/header-main-video.mp4',
        posterUrl: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/header-poster.png',
        logoHeight: '70',
        includeLogo: true,
        backgroundVideoUrl:
          'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/header-background-video.mp4',
      },
    },
    {
      meta: {
        id: 'j8QheYZlrJ',
        order: 1,
        layout: '',
        _columns: 1,
        component: 'Container',
        isFullWidth: true,
      },
      styles: {
        rowGap: '1rem',
        columnGap: '2rem',
        customClasses: 'BackgroundSecondary',
      },
      content: [
        [
          {
            meta: {
              id: 'PgnpTaFVew',
              order: 2,
              component: 'Card',
            },
            styles: {
              customClasses: 'PartnershipCard',
            },
            content: {
              image: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/partnership.png',
              title: 'Overarching Partnership Goals',
              variant: 'horizontalRight',
              subtitle:
                '<p>Adobe and Luma have joined forces to create a strategic partnership aimed at providing innovative and efficient solutions for businesses of all sizes. The partnership combines Adobe&rsquo;s expertise in digital marketing, content creation, and customer experience.</p>',
              alignment: 'left',
              selectable: false,
              titleLevel: 1,
              buttonLabel: '',
              buttonVariant: 'cta',
              verticalAlignment: 'middle',
            },
          },
        ],
      ],
    },
    {
      meta: {
        id: 'hd7ouIYtS1',
        order: 2,
        layout: '',
        _columns: 1,
        component: 'Container',
        isFullWidth: true,
      },
      styles: {
        rowGap: '',
        columnGap: '',
        customClasses: '',
      },
      content: [
        [
          {
            meta: {
              id: 'c5kie_wniX',
              order: 3,
              component: 'Title',
            },
            styles: {
              customClasses: '',
            },
            content: {
              level: 1,
              title: 'Thrive on a Shared Vision',
              subtitle: '<p>This is a subheading to complete the title description</p>',
              alignment: 'center',
              textAlignment: 'center',
            },
          },
          {
            meta: {
              id: 'rbwwM__KRc',
              order: 3,
              component: 'CustomerHubSharedVision',
            },
            styles: {
              customClasses: '',
            },
            content: {
              mode: 'user',
              leftImage:
                'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/shared-vision-left.png',
              leftQuote:
                '<p style="text-align: justify;">Your company&rsquo;s ability to understand our unique business needs and deliver customized IT solutions that align with our goals and budget has been invaluable.</p>',
              rightImage:
                'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/shared-vision-right.png',
              rightQuote:
                '<p style="text-align: justify;">Your company&rsquo;s ability to understand our unique business needs and deliver customized IT solutions that align with our goals and budget has been invaluable.</p>',
              leftDetails: '<h3><strong>Matthew Lawrence</strong></h3>\n<p><em>CEO Luma</em></p>',
              rightDetails: '<h3><strong>Shantanu Narayen</strong></h3>\n<p><em>CEO Adobe</em></p>',
              leftLogoHeight: '',
            },
          },
        ],
      ],
    },
    {
      meta: {
        id: 'edO65GmYxh',
        order: 3,
        layout: '',
        _columns: 1,
        component: 'Container',
        isFullWidth: true,
      },
      styles: {
        customClasses: 'StrategicPillars',
      },
      content: [
        [
          {
            meta: {
              id: '5Aj0iJcxia',
              order: 4,
              component: 'Card',
            },
            styles: {
              customClasses: 'PillarsHeader BackgroundPrimary',
            },
            content: {
              title: 'Strategic Pillars',
              variant: 'vertical',
              subtitle:
                '<h3><strong>2x less overload</strong></h3>\n<p>Delivery</p>\n<p>&nbsp;</p>\n<h3><strong>-50%</strong></h3>\n<p>Carbon footprint in 2023</p>\n<p>&nbsp;</p>\n<h3><strong>2x</strong></h3>\n<p>Revenue by end of 2030</p>',
              selectable: false,
              titleLevel: 1,
              buttonLabel: '',
              buttonIsQuiet: false,
              buttonVariant: 'secondary',
            },
          },
          {
            meta: {
              id: 'ipCNrizZ7S',
              order: 0,
              component: 'CustomerHubStrategicPillar',
            },
            styles: {
              customClasses: 'BackgroundSecondary',
            },
            content: {
              svg: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/pillar1.svg',
              mode: 'user',
              title: 'Integration',
              subtitle:
                '<p style="text-align: justify;">This will enable small and medium-sized businesses to seamlessly manage their shipping and logistics operations while also leveraging Adobe&rsquo;s powerful marketing tools.</p>',
              titleLevel: 3,
            },
          },
          {
            meta: {
              id: 'iYmevCB1xX',
              order: 0,
              component: 'CustomerHubStrategicPillar',
            },
            styles: {
              customClasses: 'BackgroundSecondary',
            },
            content: {
              svg: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/pillar2.svg',
              mode: 'user',
              title: 'Simplification of E-commerce',
              subtitle:
                '<p>The partnership aims to provide SMBs with a one-stop-shop for their e-commerce needs, from creating and managing digital content to handling shipping and logistics.&nbsp;</p>',
              titleLevel: 3,
            },
          },
          {
            meta: {
              id: 'UmLDZa11fc',
              order: 0,
              component: 'CustomerHubStrategicPillar',
            },
            styles: {
              customClasses: 'BackgroundSecondary',
            },
            content: {
              svg: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/pillar3.svg',
              mode: 'user',
              title: 'Innovation and Growth',
              subtitle:
                '<p>Adobe and Luma are committed to working together to develop new solutions and services that will help SMBs to grow and succeed in an increasingly areas.</p>',
              titleLevel: 3,
            },
          },
        ],
      ],
    },
    {
      meta: {
        id: 'z1Q2BhESfn',
        order: 4,
        layout: '',
        _columns: 1,
        component: 'Container',
        isFullWidth: true,
      },
      styles: {
        rowGap: '',
        columnGap: '',
        customClasses: 'EmbeddedVideo BackgroundPrimary',
      },
      content: [
        [
          {
            meta: {
              id: 'OzNkqOC$DU',
              order: 1,
              component: 'Title',
            },
            content: {
              level: 1,
              title: 'Embedded Video',
              alignment: 'center',
              textAlignment: 'center',
            },
          },
          {
            meta: {
              id: 'qpu4rd7F5B',
              order: 0,
              component: 'CustomerHubVisionDemo',
            },
            styles: {},
            content: {
              mode: 'user',
              xdUrl: '',
              videoUrl:
                'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/embedded-video.mp4',
            },
          },
        ],
      ],
    },
    {
      meta: {
        id: '_Glhy1Y_c6',
        order: 5,
        layout: '',
        _columns: 1,
        component: 'Container',
        isFullWidth: true,
      },
      styles: {
        rowGap: '',
        columnGap: '',
        customClasses: 'BackgroundSecondary',
      },
      content: [
        [
          {
            meta: {
              id: 'KJzlWB7zee7',
              order: 8,
              component: 'Title',
            },
            content: {
              level: 1,
              title: 'Unique Messaging',
              subtitle: '<p>This should be a concise summary of how Adobe will support customer&rsquo;s vision</p>',
              alignment: 'center',
              textAlignment: 'center',
            },
          },
          {
            meta: {
              id: 'kS9EjFjkp3L',
              order: 8,
              layout: '',
              _columns: 3,
              component: 'Container',
              isFullWidth: false,
            },
            styles: {
              rowGap: '',
              columnGap: '',
              customClasses: 'Tiles',
            },
            content: [
              [
                {
                  meta: {
                    id: '1pZsEB9eTvw',
                    order: 8,
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                    backgroundColor: 'var(--backgroundColor)',
                  },
                  content: {
                    link: 'external:https://www.adobe.com',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/unique-messaging-1.png',
                    title: 'Increase Website Traffic',
                    variant: 'vertical',
                    subtitle:
                      '<p>Company uses Adobe Advertising Cloud to improve targeting and optimize campaigns in real time.</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Check Adobe Story',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                },
              ],
              [
                {
                  meta: {
                    id: 'DE_hTDLn1Ex',
                    order: 8,
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                    backgroundColor: 'var(--backgroundColor)',
                  },
                  content: {
                    link: 'external:https://www.adobe.com',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/unique-messaging-2.png',
                    title: 'Aligned Customer Business',
                    variant: 'vertical',
                    subtitle: '<p>Company uses Adobe Advertising Cloud to improve targeting and optimize...</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Check Adobe Story',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                },
              ],
              [
                {
                  meta: {
                    id: 'a5gmX3oDeHC',
                    order: 5,
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                    backgroundColor: 'var(--backgroundColor)',
                  },
                  content: {
                    link: 'external:https://www.adobe.com',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/unique-messaging-3.png',
                    title: 'Reference Acquisition',
                    variant: 'vertical',
                    subtitle: '<p>Company uses Adobe Advertising Cloud to improve targeting and optimize...</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Check Adobe Story',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                },
              ],
            ],
          },
        ],
      ],
    },
    {
      meta: {
        id: 'Iud0iEmIKLl',
        order: 6,
        layout: '',
        _columns: 1,
        component: 'Container',
        isFullWidth: true,
      },
      styles: {
        rowGap: '1rem',
        columnGap: '2rem',
        customClasses: '',
      },
      content: [
        [
          {
            meta: {
              id: 'CA7sxcEAi9P',
              order: 7,
              component: 'Title',
            },
            content: {
              level: 1,
              title: 'Success Stories Evolution',
              subtitle: '<p>These are our favourites customer success stories examples</p>',
              alignment: 'center',
              textAlignment: 'center',
            },
          },
          {
            meta: {
              id: 'xUU_yrJNAGW',
              order: 8,
              layout: '',
              _columns: 1,
              component: 'Container',
              isFullWidth: true,
            },
            styles: {
              rowGap: '',
              columnGap: '',
              customClasses: 'SuccessStories',
            },
            content: [
              [
                {
                  meta: {
                    id: 'SKVs7_XHNWL',
                    order: 11,
                    component: 'CustomerHubSuccessStory',
                  },
                  styles: {
                    customClasses: 'BackgroundSecondary',
                  },
                  content: {
                    link: 'external:https://www.adobe.com',
                    logo: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/bodea.svg',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/success-stories-1.png',
                    title: 'Company and Adobe the  new era of creativity',
                    details: '',
                    subtitle:
                      '<p>Large organizations with global reach rely on new technologies ranging from cloud computing to robotic process automation - to make their operations and workflows smoother, faster and more efficient. The pandemic has only concentrated efforts.</p>',
                    selectable: false,
                    titleLevel: 3,
                    buttonLabel: 'Adobe creative direction article',
                  },
                },
                {
                  meta: {
                    id: 'rtXz4vddmgZ',
                    order: 11,
                    component: 'CustomerHubSuccessStory',
                  },
                  styles: {
                    customClasses: 'BackgroundSecondary',
                  },
                  content: {
                    link: 'external:https://www.adobe.com',
                    logo: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/halliby.svg',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/success-stories-2.png',
                    title: 'Adobe the modernization  of digital experiences',
                    details: '',
                    subtitle:
                      '<p>Adobe is also sharing an update on its Government Rapid Response Program, first introduced to support continuity during the pandemic when consumers rushed online to access government services. As vaccines ramp up.</p>',
                    selectable: false,
                    titleLevel: 2,
                    buttonLabel: 'Customer experience outcomes',
                  },
                },
              ],
            ],
          },
        ],
      ],
    },
    {
      meta: {
        id: 'VFg8QgVg45A',
        order: 7,
        layout: '',
        _columns: 1,
        component: 'Container',
        isFullWidth: true,
      },
      styles: {
        rowGap: '1rem',
        columnGap: '2rem',
        customClasses: 'BackgroundPrimary',
      },
      content: [
        [
          {
            meta: {
              id: 'HskODruWUfj',
              order: 9,
              component: 'Title',
            },
            content: {
              level: 1,
              title: 'Additional Deliverables',
              alignment: 'center',
              textAlignment: 'center',
            },
          },
          {
            meta: {
              id: 'KmI4ZfTQvQB',
              order: 9,
              layout: '',
              _columns: 4,
              component: 'Container',
              isFullWidth: false,
            },
            styles: {
              rowGap: '',
              columnGap: '',
              customClasses: 'Deliverables',
            },
            content: [
              [
                {
                  meta: {
                    id: '6IXg95RibDa',
                    order: 9,
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                  },
                  content: {
                    link: 'external:https://www.adobe.com',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/deliverables-1.png',
                    title: 'Marketing Assets for E-commerce',
                    variant: 'vertical',
                    subtitle: '<p>PDF File</p>',
                    alignment: 'left',
                    buttonLink: '',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'See more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                },
              ],
              [
                {
                  meta: {
                    id: 'eZ01OIjcjj0',
                    order: 9,
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                  },
                  content: {
                    link: 'external:https://www.adobe.com',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/deliverables-2.png',
                    title: 'Architecture Flow for Research Scenarios',
                    variant: 'vertical',
                    subtitle: '<p>Video Tutorial</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Watch Video',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                },
              ],
              [
                {
                  meta: {
                    id: 'VeEqGGd_e51',
                    order: 9,
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                  },
                  content: {
                    link: 'external:https://www.adobe.com',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/deliverables-3.png',
                    title: 'Technical Use Cases and Validation',
                    variant: 'vertical',
                    subtitle: '<p>PDF file</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Download Materials',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                },
              ],
              [
                {
                  meta: {
                    id: 'RPL1D19WMfy',
                    order: 9,
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                  },
                  content: {
                    link: 'external:https://www.adobe.com',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/deliverables-4.png',
                    title: 'Experience League Tutorial for Brand Designers',
                    variant: 'vertical',
                    subtitle: '<p>Adobe tutorial</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: "Check Adobe's Platform",
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                },
              ],
            ],
          },
        ],
      ],
    },
    {
      meta: {
        id: '1MnK8DleT0a',
        order: 8,
        layout: '',
        _columns: 1,
        component: 'Container',
        isFullWidth: true,
      },
      styles: {
        rowGap: '1rem',
        columnGap: '2rem',
        customClasses: 'BackgroundPrimary',
      },
      content: [
        [
          {
            meta: {
              id: 'DszNXqQw4V6',
              order: 11,
              component: 'Title',
            },
            content: {
              level: 1,
              title: 'Your Adobe Team',
              pretitle: '',
              subtitle: "<p>We're here to help</p>",
              alignment: 'center',
              textAlignment: 'center',
            },
          },
          {
            meta: {
              id: 'TrB1Va1GCka',
              order: 12,
              component: 'GridContainer',
              isFullWidth: false,
            },
            styles: {
              rowGap: '',
              columnGap: '',
              customClasses: 'AccountTeam',
              gridTemplateRows: '',
              gridTemplateColumns: '',
            },
            content: [
              {
                meta: {
                  id: 'ligUNHkYT6N',
                  order: 11,
                  component: 'Card',
                },
                content: {
                  image: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/Persona 5.png',
                  title: 'Lisa Anderson',
                  variant: 'vertical',
                  subtitle: '<p>Account Director</p>\n<p>SALES</p>',
                  selectable: false,
                  titleLevel: 5,
                },
              },
              {
                meta: {
                  id: 'MRQh3zjkKFF',
                  order: 11,
                  component: 'Card',
                },
                content: {
                  image: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/Persona 4.png',
                  title: 'Amit Smith',
                  variant: 'vertical',
                  subtitle: '<p>Account Manager</p>\n<p>SALES</p>',
                  selectable: false,
                  titleLevel: 5,
                },
              },
              {
                meta: {
                  id: '2CZkpThXWR6',
                  order: 11,
                  component: 'Card',
                },
                content: {
                  image: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/Persona 3.png',
                  title: 'Alexander Peterson',
                  variant: 'vertical',
                  subtitle: '<p>Solutions Consultant</p>\n<p>SALES</p>',
                  selectable: false,
                  titleLevel: 5,
                },
              },
              {
                meta: {
                  id: 'KADKCsXWVa9',
                  order: 11,
                  component: 'Card',
                },
                content: {
                  image: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/Persona 2.png',
                  title: 'Diana Leith',
                  variant: 'vertical',
                  subtitle: '<p>Product Manager</p>\n<p>PRODUCT</p>',
                  selectable: false,
                  titleLevel: 5,
                },
              },
            ],
          },
        ],
      ],
    },
    {
      meta: {
        id: 'VLoEnukRlSS',
        order: 9,
        layout: 'wrap',
        component: 'List',
        isFullWidth: false,
        itemAlignment: 'left',
      },
      styles: {
        customClasses: 'BackgroundPrimary footer',
      },
      content: [
        {
          meta: {
            id: '7Lu8fu9QliJ',
            order: 11,
            component: 'CustomerHubLogo',
          },
          content: {
            mode: 'user',
            logoHeight: '70',
            showScrollUpButton: true,
          },
        },
      ],
    },
  ],
}
